export default __webpack_public_path__ + "static/media/screen3.4954e294.png";